export default {
  HOLDING: 'HOLDING',
  PARTNER: 'PARTNER',
  ADMIN: 'ADMIN',
};
